import React from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton } from "office-ui-fabric-react";

export const ConfirmationDialog = ({ hidden, dialogContentProps, primaryButtonProps, onCancel }) => {
  return (
    <Dialog
      hidden={hidden}
      onDismiss={onCancel}
      dialogContentProps={{
        type: DialogType.normal,
        ...dialogContentProps
      }}
      modalProps={{
				titleAriaId: 'myLabelId',
				subtitleAriaId: 'mySubTextId',
				isBlocking: false
			}}
    >
      <DialogFooter>
        <DefaultButton onClick={onCancel} text="Cancel" />
        <PrimaryButton iconProps={primaryButtonProps.iconProps} onClick={primaryButtonProps.onClick} text={primaryButtonProps.text} />
      </DialogFooter>
    </Dialog>
  );
};


// WEBPACK FOOTER //
// ./src/components/dialogs/confirmationDialog.js